import React from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Row, Col, Button, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import { XCircle } from 'lucide-react';

const MerchantDeclined = () => {
    const { state } = useLocation();
    const merchant = state?.merchant;

    if (!merchant) {
        return <div>Merchant data not found.</div>;
    }

    return (
        <Container className="mt-5">
            <Row className="justify-content-center">
                <Col md="8">
                    <Card className="text-center">
                        <CardBody>
                            <XCircle size={48} color="#33bdbf" />
                            <CardTitle tag="h2" className="mt-3">Your merchant application has been declined</CardTitle>
                            <CardText className="mt-3">Reason for decline:</CardText>
                            <CardText style={{ fontSize: '1.2rem', color: '#333' }}>
                                {merchant?.declinedReason || 'No reason provided'}
                            </CardText>
                            {/* <Button color="primary" href="/merchant/details" className="mt-4">
                                Go to Merchant Details
                            </Button> */}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default MerchantDeclined;
